import './MoreDropdown.scss';

import { mdiDotsVertical } from '@mdi/js';
import type { DropdownProps, MenuProps } from 'antd';
import { Dropdown } from 'antd';
import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import type { ExtendedMenuItem } from 'components/Menu/Menu';
import React from 'react';

interface Props {
  items: ExtendedMenuItem[];
  menuProps?: MenuProps;
  className?: string;
  buttonProps?: React.ComponentProps<typeof Button>;
  placement?: DropdownProps['placement'];
}

const MoreDropdown: React.FC<Props> = (props): React.ReactElement => {
  const filteredItems = props.items.filter((x) => !x.hidden);

  if (filteredItems.length < 1) return <div />;

  return (
    <Dropdown
      menu={{ ...props.menuProps, items: filteredItems }}
      trigger={['click']}
      placement={props.placement}
      classNames={{ root: 'MoreDropdownOverlay' }}
    >
      {/* When dropdown is part of selectable item we need to stopPropagation otherwise item is selected and dropdown not opened */}
      <span
        className={`MoreDropdown ${props.className || ''}`}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <Button ghost icon={<Icon path={mdiDotsVertical} />} {...props.buttonProps} />
      </span>
    </Dropdown>
  );
};

export default MoreDropdown;
